"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var Plottable = _interopRequireWildcard(require("plottable"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var createHoverInteraction = function createHoverInteraction(props) {
  var _props = props(),
    plot = _props.plot,
    onHover = _props.onHover;
  var pointer = new Plottable.Interactions.Pointer();
  pointer.onPointerMove(function (point) {
    var entity = plot instanceof Plottable.Plots.Line ? plot.entityNearest(point) : plot.entitiesAt(point)[0];
    if (!entity || entity.datum == null) {
      return;
    }
    var hover = {
      anchorX: entity.position.x,
      anchorY: entity.position.y,
      plotWidth: entity.component.width(),
      plotHeight: entity.component.height(),
      datum: entity.datum
    };
    onHover({
      hover: hover
    });
  });
  pointer.onPointerExit(function () {
    onHover({
      hover: null
    });
  });
  return pointer;
};
var _default = exports["default"] = createHoverInteraction;
//# sourceMappingURL=createHoverInteraction.js.map